import { useContext } from 'react'
import { useQueries } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getEmployeeDuties = async (token, id) => {
  const url = `employees/${id}/duties`
  const data = await apiGet({ url, token })
  return data
}

// Fetches the SOD duties (and therefore roles) for several employees at once so
// the compare grid can build a union of roles across the selected users. Shares
// the same query cache key shape as `useEmployeeDuties` so detail-page loads are
// reused.
export default function useEmployeesRoles(employeeIds = []) {
  const token = useContext(AuthContext)

  return useQueries(
    employeeIds.map((id) => ({
      queryKey: ['employees-duties', { id: String(id) }],
      queryFn: () => getEmployeeDuties(token, id),
      enabled: Boolean(id)
    }))
  )
}
